import moment from 'moment';

export function parseDate(input: string, isFromStartDate: boolean): string {
    const s = input.split('-')
    // From start date
    if (isFromStartDate) {
        return Date.UTC(parseInt(s[0]), parseInt(s[1]) - 1, parseInt(s[2]), 0, 0, 0, 0).toString()
    // To start date
    } else {
        return Date.UTC(parseInt(s[0]), parseInt(s[1]) - 1, parseInt(s[2]), 23, 59, 59, 999).toString()
    }
}

export function prettifyDateUTC(date: Date): string {
    return moment(date).utc().format('YYYY-MM-DD HH:mm:ss') + "Z"
}

export function prettifyDateLocal(date: Date): string {
    return moment(date).local().format('YYYY-MM-DD HH:mm:ssZ')
}